fx.ns("desktop.common.zoom", class ZoomWidget extends fx.Component{
    
	constructor(model, board, options)
	{
		super();
		
		this._model = model;
		this._board = board;
		this._options = options;

		this.book = this._model.creation;
	}

	get options()
    {
        return this._options;
    }

	get model()
    {
        return this._model;
    }

    set model(val)
    {
        this._model = val;
    }


	get book()
	{
		return this.data;
	}

	set book(val)
	{
		this.data = val;

		if (this.previewBox)
			this.previewBox.book = val;
	}

	get board()
	{
		return this._board;
	}

	set board(val)
	{
		this._board = val;

		if(this.previewBox)
			this.previewBox.board = val;
	}

	show(callback)
	{
		super.show(callback);

		this.previewBox.updateStage();
	}
	
	onReady()
	{
		super.onReady();	

		this.on("close", this.onClose, this.zoomBar);

		this.previewBox.book = this.book;
	}

	create(){
		super.create();

		this.previewBox = new desktop.common.zoom.PreviewBox(this.model, this.board);
		this.addChild(this.previewBox,  {bottom:50, left:0, width:"100%", height:140});
		
		this.zoomBar = new desktop.common.zoom.ZoomBar(this.model);
		this.addChild(this.zoomBar,  {top:0, left:0, width:"100%", height:"100%"});
	}


	onClose()
	{
		this.trigger("close");
	}


	destroy()
	{
		super.destroy();

		this.zoomBar.destroy();

		this.previewBox.destroy();
		
	}
	
});